import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  modalBody: {
    borderRadius: 4,
    backgroundColor: "#ffffff",
    width: "100%",
    padding: "0px !important",
    height: "70vh",
    minHeight: 700,
  },
  searchSection: {
    "& > section": {
      maxWidth: 500,
      "& > h1": {
        marginBottom: "2.5rem",
      },
    },
  },
  textfieldStyle: {
    "& ~ img": {
      position: "absolute",
      left: 5,
    },
    "& > div": {
      paddingLeft: 40,
    },
    "& > div > input": {
      color: "#000000",
      padding: "9px 0 14px",
    },
    "& > div::after": {
      borderColor: "#000000",
    },
  },
  contentWrap: {
    flex: 1,
    width: "100%",
    "& > ul": {
      listStyle: "none",
      marginTop: 15,
      overflowY: "auto",
      maxHeight: 450,
      "&::-webkit-scrollbar": {
        "-webkit-appearance": "none",
      },
      "&::-webkit-scrollbar:vertical": {
        width: 2,
      },
      "&::-webkit-scrollbar-thumb": {
        borderRadius: 8,
        border: "1px solid #b6b6b6",
        backgroundColor: "#b6b6b6",
      },
      "& li.data-shown": {
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        padding: "10px 20px 10px 0",
        alignItems: "center",
        fontSize: 14,
        "& img": {
          position: "relative",
          maxWidth: 15,
          right: 10,
          transitionDuration: "0.1s",
        },
        "&:hover img": {
          right: 0,
        },
      },
    },
  },
  noDataShown: {
    padding: "10px 20px 10px 0",
    display: "flex",
    color: "#878889",
    cursor: "default",
    justifyContent: "center",
  },
  colorSection: {
    backgroundColor: "#F5F5F5",
    "& > h2": {
      fontSize: 16,
    },
  },
  colorGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, 177px)",
    gridRowGap: 8,
    gridColumnGap: 8,
  },
  item: {
    height: 116,
    width: "100%",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: 8,
    cursor: "pointer",

    "& > img": {
      borderRadius: 8,
      maxWidth: "100%",
      position: "absolute",
      bottom: 0,
    },
    "& > span": {
      position: "absolute",
      left: "50%",
      top: "50%",
      fontSize: 12,
      fontWeight: 600,
      width: "100%",
      textAlign: "center",
      paddingTop: 15,
      color: "#fff",
      textTransform: "capitalize",
      padding: 5,
      transform: "translate(-50%, -50%)",
    },
  },
}));
